module.exports = __webpack_public_path__ + "img/r-80.cb8ad3e7.jpg";